<template>
  <div class="base-tabs">
    <ul class="tabs__header grabbable">
      <li
        v-for="(tab, index) in tabs"
        :key="tab.title"
        @click="selectTab(index)"
        :class="{ tabs__selected: index == selectedIndex }"
      >
        <span>
          {{ tab.title }}
        </span>
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "GrowerWebBaseTabs",

  data() {
    return {
      selectedIndex: 0, // the index of the selected tab,
      tabs: [], // all of the tabs
    };
  },

  created() {
    this.tabs = this.$children;
  },

  mounted() {
    this.draggable();
    this.selectTab(0);
  },

  methods: {
    draggable() {
      const slider = document.querySelector(".grabbable");
      if (!slider) return;

      let mouseDown = false;
      let startX, scrollLeft;
      let startDragging = function (e) {
        mouseDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      };

      let stopDragging = function (event) {
        mouseDown = false;
      };

      slider.addEventListener("mousemove", (e) => {
        e.preventDefault();
        if (!mouseDown) {
          return;
        }
        const x = e.pageX - slider.offsetLeft;
        const scroll = x - startX;
        slider.scrollLeft = scrollLeft - scroll;
      });

      slider.addEventListener("mousedown", startDragging, false);
      slider.addEventListener("mouseup", stopDragging, false);
      slider.addEventListener("mouseleave", stopDragging, false);
    },
    selectTab(i) {
      this.selectedIndex = i;

      // loop over all the tabs
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i;
      });
    },
  },
};
</script>

<style>
.base-tabs {
}
ul.tabs__header {
  display: flex;
  list-style: none;
  padding: 0;
  overflow: hidden;
}

ul.tabs__header > li {
  list-style: none;
  margin: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  padding: 4px 0px;
  cursor: pointer;
  border-bottom: 4px solid transparent;
  text-align: center;
  vertical-align: middle;
  clear: both;
  white-space: nowrap;
  width: fit-content;
}

ul.tabs__header > li.tabs__selected {
  border-color: var(--primary-color);
  font-weight: bolder;
}

ul.tabs__header > li.tab__selected {
  font-weight: bold;
  border-radius: 10px 10px 0 0;
  border-bottom: 8px solid transparent;
}

.grabbable {
  cursor: move;
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
.grabbable:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
</style>


// WEBPACK FOOTER //
// src/base/component/base-tabs.vue